module.exports = __webpack_public_path__ + "static/pier1_card-f6d44380be06f51d0b4352573c2a0c99.png";